// extracted by mini-css-extract-plugin
export default {"textAlignActionBar":"TextAlignActionBar_textAlignActionBar__Erl9E"};